// extracted by mini-css-extract-plugin
export default {"Loading-ocean":"theme-ocean_Loading-ocean__mUbxm","Circle-ocean":"theme-ocean_Circle-ocean__1pMYI","loading":"theme-ocean_loading__nKzZk"};